<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("gestionDePersonal") }}
            </li>
          </ol>
        </nav>
        <vue-tabs>
          <v-tab icon="far fa-calendar-alt" :title="$t('gestionDePersonal')">
            <div class="row">
              <div class="col-md-6" v-show="permisoBusiness && permisoUsuario">
                <label></label><br />
                <button
                  class="btn btn-success"
                  @click="
                    (turnoCreate = false),
                      (turnoFijo = false),
                      openModalAgregarTurnoOperario()
                  "
                >
                  <i class="fas fa-plus"></i> {{ $t("asignarTurno") }}
                </button>

                <template v-if="!filtro">
                  <template>
                    <button
                      @click="(filtro = 2), getRegistrosTurnosOperario()"
                      class="btn btn-warning"
                      style="background-color: #ff6400"
                    >
                      <i class="fas fa-umbrella-beach"></i>
                      {{ $t("vacaciones") }}
                    </button>
                  </template>

                  <el-badge :value="incidencias" class="item" type="danger">
                    <button
                      @click="(filtro = 1), getRegistrosTurnosOperario()"
                      class="btn btn-danger"
                    >
                      <i class="fas fa-exclamation"></i> {{ $t("incidencias") }}
                    </button>
                  </el-badge>
                </template>
                <template v-else>
                  <button
                    @click="(filtro = 0), getRegistrosTurnosOperario()"
                    class="btn btn-primary"
                  >
                    <i class="far fa-eye"></i> {{ $t("verTodos") }}
                  </button>
                </template>

                <a
                  v-if="nameView === 'agendaWeek' && events.length > 0"
                  :href="exportHorario"
                >
                  <button class="btn btn-primary">
                    <i class="far fa-file-pdf"></i> {{ $t("descargarPDF") }}
                  </button>
                </a>

                <button
                  class="btn btn-info"
                  v-if="nameView === 'agendaWeek' && events.length > 0"
                  @click="sendEmail()"
                >
                  <i class="fas fa-paper-plane"></i> {{ $t("enviarHorario") }}
                </button>

                <!--                                <button v-if="nameView!=='month'" @click="entryCopyTurn()" class="btn btn-default">-->
                <!--                                    <i class="fas fa-exchange-alt"></i> Copiar horario-->
                <!--                                </button>-->
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label
                    ><strong>{{ $t("negocio") }}</strong></label
                  >
                  <el-select
                    class="select-default"
                    size="large"
                    v-model="idBusiness"
                    filterable
                    @change="comprobarPermisos()
                      
                    "
                    :placeholder="$t('seleccionaNegocio')"
                  >
                    <el-option
                      v-for="business in listBusinesses"
                      class="select-primary"
                      :value="business.id"
                      :label="business.establishmentName"
                      :key="business.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="col-md-3" v-show="permisoBusiness && permisoUsuario">
                <div class="form-group">
                  <label
                    ><strong>{{ $t("operario") }}</strong></label
                  >
                  <el-select
                    class="select-default"
                    size="large"
                    v-model="idOperarioFiltro"
                    filterable
                    @change="getRegistrosTurnosOperario()"
                    :placeholder="$t('seleccionaOperario')"
                  >
                    <el-option
                      v-for="ope in listFiltradoOperario"
                      class="select-primary"
                      :value="ope.id"
                      :label="ope.name"
                      :key="ope.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="col-md-12">
                <template v-if="idOperarioFiltro !== 0">
                  <small class="text-danger" style="float: right">
                    <strong>
                      <i class="fas fa-exclamation"></i> {{ incidencias }}
                      {{ $t("incidenciasEnElMes") }}
                    </strong>
                  </small>
                  <small
                    class="text-warning"
                    style="float: right; margin-right: 20px"
                  >
                    <strong>
                      <i class="fas fa-umbrella-beach"></i> {{ vacaciones }}
                      {{ $t("diasDeVacacionesEnElMes") }}
                    </strong>
                  </small>
                  <small style="float: right; margin-right: 20px"
                    ><strong
                      ><i class="fas fa-umbrella-beach"></i>
                      {{ vacacionesTodas }}
                      {{ $t("diasDeVacacionesEnElAno") }}</strong
                    >
                  </small>
                </template>
              </div>
              <div class="col-md-12" v-show="permisoBusiness && permisoUsuario">
                <card class="card-calendar">
                  <div id="fullCalendar"></div>
                </card>
              </div>
              <div class="col-md-12" v-show="!permisoBusiness || !permisoUsuario">
                  <div class="alert alert-danger" role="alert">
                    <span v-if="permisoBusiness">{{$t('permisoBusinessGestion')}}</span>
                    <span v-else>{{$t('permisoUsuarioGestion')}}</span>
                  </div>
              </div>
            </div>
          </v-tab>
          <v-tab icon="fas fa-cog" :title="$t('configuracionTurnos')">
            <div class="card">
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t("negocio") }}</label>
                  <el-select
                    class="select-default"
                    size="large"
                    v-model="idBusiness"
                    filterable
                    @change="
                      comprobarPermisos()
                    "
                    :placeholder="$t('seleccionaNegocio')"
                  >
                    <el-option
                      v-for="business in listBusinesses"
                      class="select-primary"
                      :value="business.id"
                      :label="business.establishmentName"
                      :key="business.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="card" v-if="permisoBusiness && permisoUsuario">
              <div class="row">
                <div class="col-md-12">
                  <template v-if="clonacionTurno">
                    <button
                      v-if="listTurnClon.length > 0"
                      class="btn btn-success"
                      @click="$modal.show('clonarTurnosModal')"
                    >
                      <i class="fas fa-save"></i> {{ $t("guardar") }}
                    </button>
                    <button
                      class="btn btn-danger"
                      @click="clonacionTurno = false"
                    >
                      <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
                    </button>

                    <div class="float-right">
                      <input
                        v-model="selectAll"
                        @change="seleccionarTodos()"
                        type="checkbox"
                      />
                      {{ $t("seleccionarTodos") }}
                    </div>
                  </template>
                  <template v-else>
                    <button
                      class="btn btn-success"
                      @click="openModalAgregarTurno"
                    >
                      <i class="fas fa-plus"></i> {{ $t("nuevoTurno") }}
                    </button>
                    <button class="btn btn-info" @click="clonacionTurno = true">
                      <i class="fas fa-clone"></i> {{ $t("clonarTurno") }}
                    </button>
                  </template>
                </div>
                <div class="table-responsive col-md-12">
                  <table class="table table-bordered table-striped">
                    <thead class="thead-dark">
                      <tr>
                        <th>{{ $t("nombreDelTurno") }}</th>
                        <th>{{ $t("horarioInicio") }}</th>
                        <th>{{ $t("horaFin") }}</th>
                        <th>{{ $t("diasDeLaSemana") }}</th>
                        <th>{{ $t("acciones") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="t.id >= 0" v-for="t in listTurnos">
                        <td>{{ t.nombreTurno }}</td>
                        <td>{{ t.horaInicio }}</td>
                        <td>{{ t.horaFin }}</td>
                        <td>
                          <template v-for="d in t.diasSemanales">
                            <template>{{ d }},</template>
                          </template>
                        </td>
                        <td>
                          <div
                            v-tooltip.top-center="$t('editarTurno')"
                            class="btn btn-primary btn-link"
                            @click="openModalEditarTurno(t)"
                          >
                            <i class="fas fa-edit text-warning"></i>
                          </div>

                          <div
                            class="btn btn-primary btn-link"
                            v-tooltip.top-center="$t('borrarTurno')"
                            @click="showModalBorrarTurno(t.id)"
                          >
                            <i class="fas fa-trash-alt text-danger"></i>
                          </div>

                          <div
                            class="btn btn-primary btn-link"
                            v-tooltip.top-center="$t('clonarTurno')"
                          >
                            <template v-if="clonacionTurno">
                              <el-checkbox-group v-model="listTurnClon">
                                <el-checkbox :label="t.id"
                                  ><i class="fas fa-clone"></i>
                                </el-checkbox>
                              </el-checkbox-group>
                            </template>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">
                  <span v-if="permisoBusiness">{{$t('permisoBusinessGestion')}}</span>
                  <span v-else>{{$t('permisoUsuarioGestion')}}</span>
                </div>
              </div>
            </div>
          </v-tab>
        </vue-tabs>
      </div>
      <!--MODALES CALENDARIO-->
      <modal
        name="agregarEventoModal"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">
              <template v-if="!editEvento">{{ $t("nuevo") }}</template>
              <template v-else>{{ $t("editar") }}</template>
              {{ $t("evento") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="textEvent"
                    ><strong>{{ $t("nombreEvento") }}</strong></label
                  >
                  <input
                    id="textEvent"
                    class="form-control"
                    :disabled="textEvent !== ''"
                    v-model="textEvent"
                  />
                </div>
              </div>
              <template v-if="event.tipo === 0">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("horaInicio") }}</label>
                    <datetime
                      value-zone="Europe/Madrid"
                      :auto="true"
                      type="time"
                      class="theme-numier"
                      :title="$t('horaInicio')"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      format="HH:mm"
                      v-model="hoursfrom"
                    ></datetime>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("horaFin") }}</label>
                    <datetime
                      value-zone="Europe/Madrid"
                      :auto="true"
                      type="time"
                      class="theme-numier"
                      :title="$t('horaFin')"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      format="HH:mm"
                      v-model="hoursto"
                    ></datetime>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      ><strong
                        >{{ $t("fechaInicio")
                        }}<span class="text-danger">*</span></strong
                      >
                    </label>
                    <datetime
                      value-zone="Europe/Madrid"
                      :auto="true"
                      class="theme-numier"
                      format="dd-MM-yyyy"
                      :title="$t('fechaInicio')"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      v-model="turnOperario.datefrom"
                    ></datetime>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      ><strong
                        >{{ $t("fechaFin")
                        }}<span class="text-danger">*</span></strong
                      >
                    </label>
                    <datetime
                      value-zone="Europe/Madrid"
                      :auto="true"
                      class="theme-numier"
                      :title="$t('fechaFin')"
                      format="dd-MM-yyyy"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      v-model="turnOperario.dateto"
                    ></datetime>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button class="btn btn-default" @click="cerrarModales()">
                <i class="fa fa-times-circle"></i>
                {{ $t("cerrar") }}
              </button>
              <button
                v-if="editEvento"
                @click="checkEvento()"
                class="btn btn-success"
              >
                <i class="fa fa-plus-square"></i> {{ $t("editarTurno") }}
              </button>
              <button v-else @click="agregarEvento()" class="btn btn-success">
                <i class="fa fa-plus-square"></i> {{ $t("nuevoTurno") }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal
        name="eleccionModal"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
        :width="900"
      >
        <div
          @click="$modal.hide('eleccionModal')"
          style="margin: 5px; cursor: pointer"
          class="text-right"
        >
          <i class="fas fa-times-circle"></i>
        </div>

        <div class="modal-header">
          <div class="col-md-12">
            <div class="row">
              <div
                v-if="event.icon"
                class="col-md-12 alert alert-danger"
                role="alert"
              >
                <i class="fas fa-exclamation-triangle"></i>
                <strong>{{ $t("hayUnaIncidenciaEnEsteTurno") }}</strong>
              </div>
              <div class="col-md-12">
                <div align="center">
                  <h4>{{ event.title }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <div class="col-md-12">
            <div class="row">
              <p class="col-md-4">
                <strong>{{ $t("fechaInicioTurno") }}</strong
                ><br />
                {{ event.start | parseDateMomentMinut }}
              </p>
              <p class="col-md-4">
                <strong>{{ $t("fechaFinTurno") }}</strong
                ><br />
                {{ event.end | parseDateMomentMinut }}
              </p>
              <p class="col-md-4">
                <strong>{{ $t("numHorasTurno") }}</strong
                ><br />
                {{ event.diffHorasTurno | timago }}
              </p>

              <p class="col-md-4">
                <strong>{{ $t("fechaInicioTurno") }}</strong
                ><br />
                <template v-if="event.startReal">{{
                  event.startReal | parseDateMomentMinut
                }}</template>
                <template v-else
                  ><strong class="text-danger">{{
                    $t("noIniciado")
                  }}</strong></template
                >
              </p>
              <p class="col-md-4">
                <strong>{{ $t("fechaFinTurno") }}</strong
                ><br />
                <template v-if="event.endReal">{{
                  event.endReal | parseDateMomentMinut
                }}</template>
                <template v-else
                  ><strong class="text-danger">{{
                    $t("noFinalizado")
                  }}</strong></template
                >
              </p>
              <p class="col-md-4">
                <strong>{{ $t("numHorasTrabajadas") }}</strong
                ><br />
                <template v-if="event.endReal">{{
                  event.diffHorasTrabajadas | timago
                }}</template>
                <template v-else
                  ><strong class="text-danger">{{
                    $t("noFinalizado")
                  }}</strong></template
                >
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="col-md-12">
            <div class="row">
              <button
                class="btn btn-primary col-md-5"
                @click="openModalEditarEvento()"
              >
                <i class="far fa-edit"></i> {{ $t("editar") }}
              </button>
              <button
                class="btn btn-danger col-md-5 offset-md-2"
                @click="showModalBorrarTurnoEleccionModal()"
              >
                <i class="fa fa-times-circle"></i> {{ $t("eliminar") }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal
        name="eleccionModalVacaciones"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div class="modal-header">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12 alert alert-warning" role="alert">
                <i class="fas fa-umbrella-beach"></i>
                <strong>{{ $t("vacaciones") }}</strong>
              </div>
              <div class="col-md-12">
                <div align="center">
                  <h4>{{ event.title }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <div class="col-md-12">
            <div class="row">
              <p class="col-md-6">
                <strong>{{ $t("fechaInicioVacaciones") }}</strong
                ><br />
                {{ event.start | parseDateMoment }}
              </p>
              <p class="col-md-6">
                <strong>{{ $t("fechaFinVacaciones") }}</strong
                ><br />
                {{ event.end | parseDateMoment }}
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="col-md-12">
            <div class="row">
              <button
                class="btn btn-primary col-md-5"
                @click="openModalEditarEvento()"
              >
                <i class="far fa-edit"></i> {{ $t("editar") }}
              </button>
              <button
                class="btn btn-danger col-md-5 offset-md-2"
                @click="borrarEvento()"
              >
                <i class="fa fa-times-circle"></i> {{ $t("eliminar") }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <!--MODALES TURNOS-->
      <modal
        name="agregarTurnoModal"
        @opened="focusTurnosModal"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("turnoHorario") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group hasError">
                  <label for="nameTurn"
                    ><strong
                      >{{ $t("nombreTurno") }}
                      <span class="text-danger">*</span></strong
                    >
                    <small class="text-danger" v-if="turnError.nameTurn">{{
                      $t("campoRequerido")
                    }}</small>
                  </label>
                  <input
                    ref="nameTurn"
                    :class="{ 'is-invalid': turnError.nameTurn }"
                    id="nameTurn"
                    class="form-control"
                    v-model="turn.nameTurn"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    ><strong
                      >{{ $t("horaInicio") }}
                      <span class="text-danger">*</span></strong
                    >
                    <small class="text-danger" v-if="turnError.hoursfromTurn"
                      >{{ $t("campoRequerido") }}
                    </small>
                  </label>
                  <datetime
                    value-zone="Europe/Madrid"
                    :auto="true"
                    type="time"
                    class="theme-numier"
                    :title="$t('horaInicio')"
                    :class="{ 'is-invalid': turnError.hoursfromTurn }"
                    :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                    input-class="form-control"
                    format="HH:mm"
                    v-model="turn.hoursfromTurn"
                  ></datetime>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    ><strong
                      >{{ $t("horaFin") }}
                      <span class="text-danger">*</span></strong
                    >
                    <small class="text-danger" v-if="turnError.hourstoTurn">{{
                      $t("campoRequerido")
                    }}</small>
                  </label>
                  <datetime
                    value-zone="Europe/Madrid"
                    :auto="true"
                    type="time"
                    class="theme-numier"
                    :class="{ 'is-invalid': turnError.hourstoTurn }"
                    :title="$t('horaFin')"
                    :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                    input-class="form-control"
                    format="HH:mm"
                    v-model="turn.hourstoTurn"
                  ></datetime>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label
                    ><strong
                      >{{ $t("diasDeLaSemana") }}
                      <span class="text-danger">*</span></strong
                    >
                    <small class="text-danger" v-if="turnError.days">{{
                      $t("campoRequerido")
                    }}</small>
                  </label>
                  <el-select
                    v-model="turn.days"
                    multiple
                    width="100%"
                    filterable
                    :placeholder="$t('introduzcaLosDiasDeLaSemana')"
                  >
                    <el-option
                      v-for="d in daysSemanas"
                      :key="d.value"
                      :label="d.name"
                      :value="d.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button class="btn btn-danger" @click="cerrarModales">
                <i class="fa fa-times-circle"></i>
                {{ $t("cancelar") }}
              </button>

              <button
                v-if="editarTurno"
                @click="agregarRegistroTurnos()"
                class="btn btn-success"
              >
                <i class="fas fa-save"></i>
                {{ $t("guardar") }}
              </button>
              <button
                v-else
                @click="agregarRegistroTurnos()"
                class="btn btn-success"
              >
                <i class="fas fa-save"></i>
                {{ $t("guardar") }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <!--MODALES TURNOS OPERARIOS-->
      <modal
        name="agregarTurnoOperarioModal"
        @opened="focusTurnosOperarioModal"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("crearTurnoHorarioDeOperario") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label
                    ><strong
                      >{{ $t("operario") }}
                      <span class="text-danger">*</span></strong
                    >
                    <small
                      class="text-danger"
                      v-if="turnOperarioError.idOperario"
                      >{{ $t("campoRequerido") }}
                    </small>
                  </label>
                  <el-select
                    v-model="turnOperario.idOperario"
                    multiple
                    ref="idOperario"
                    width="100%"
                    filterable
                    :placeholder="$t('introduzcaLosOperarios')"
                  >
                    <el-option
                      v-for="ope in listOperarios"
                      :key="ope.id"
                      :label="ope.name"
                      :value="ope.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label
                    ><strong>{{ $t("tipo") }}</strong></label
                  >
                  <el-select
                    class="select-default"
                    size="large"
                    v-model="tipo"
                    filterable
                    :placeholder="$t('seleccionaTipoPunto')"
                  >
                    <el-option
                      class="select-primary"
                      :value="0"
                      :label="$t('laboral')"
                      :key="0"
                    >
                    </el-option>
                    <el-option
                      class="select-primary"
                      :value="1"
                      :label="$t('vacacional')"
                      :key="1"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="col-md-12" v-if="tipo === 0 && !turnoFijo">
                <div class="form-group">
                  <label
                    ><strong
                      >{{ $t("turno")
                      }}<span class="text-danger">*</span></strong
                    >
                    <small class="text-danger" v-if="turnOperarioError.idTurno"
                      >{{ $t("campoRequerido") }}
                    </small>
                  </label>
                  <el-select
                    class="select-default"
                    size="large"
                    v-model="turnOperario.idTurno"
                    filterable
                    :placeholder="$t('seleccionaTurno')"
                  >
                    <el-option
                      v-for="tur in listTurnos"
                      class="select-primary"
                      :value="tur.id"
                      :label="tur.nombreTurno"
                      :key="tur.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <template v-if="!turnoCreate">
                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      ><strong
                        >{{ $t("fechaInicio")
                        }}<span class="text-danger">*</span></strong
                      >
                      <small
                        class="text-danger"
                        v-if="turnOperarioError.datefrom"
                        >{{ $t("campoRequerido") }}
                      </small>
                    </label>
                    <datetime
                      value-zone="Europe/Madrid"
                      :auto="true"
                      class="theme-numier"
                      format="dd-MM-yyyy"
                      :title="$t('fechaInicio')"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      v-model="turnOperario.datefrom"
                    ></datetime>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      ><strong
                        >{{ $t("fechaFin")
                        }}<span class="text-danger">*</span></strong
                      >
                      <small class="text-danger" v-if="turnOperarioError.dateto"
                        >{{ $t("campoRequerido") }}
                      </small>
                    </label>
                    <datetime
                      value-zone="Europe/Madrid"
                      :auto="true"
                      class="theme-numier"
                      :title="$t('fechaFin')"
                      format="dd-MM-yyyy"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      v-model="turnOperario.dateto"
                    ></datetime>
                  </div>
                </div>
              </template> 
            <!-- nuevo -->
              <template v-if="turnOperario.idTurno==-1 && tipo != 1">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("horaInicio") }}</label>
                    <datetime
                      value-zone="Europe/Madrid"
                      :auto="true"
                      type="time"
                      class="theme-numier"
                      :title="$t('horaInicio')"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      format="HH:mm"
                      v-model="turnOperario.hoursFromCustom"  
                      ></datetime>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("horaFin") }}</label>
                    <datetime
                      value-zone="Europe/Madrid"
                      :auto="true"
                      type="time"
                      class="theme-numier"
                      :title="$t('horaFin')"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      format="HH:mm"
                      v-model="turnOperario.hoursToCustom"
                    ></datetime>
                  </div>
                </div>
              </template>         
              <!-- Hasta aqui -->
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button class="btn btn-danger" @click="cerrarModales">
                <i class="fa fa-times-circle"></i>
                {{ $t("cancelar") }}
              </button>
              <button @click="creacionArrayDia()" class="btn btn-success">
                <i class="fas fa-save"></i>
                {{ $t("guardar") }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <!--MODAL CLONAR TURNOS-->
      <modal
        name="clonarTurnosModal"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">
              {{ $t("seleccionaLosNegociosALosQueQuiereClonarElTurno") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <div class="form-group">
                <label
                  ><strong
                    >{{ $t("negocios") }}
                    <span class="text-danger">*</span></strong
                  >
                </label>
                <el-select
                  v-model="listNegociosClon"
                  multiple
                  ref="idOperario"
                  width="100%"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                >
                  <el-option
                    v-if="b.id !== idBusiness"
                    v-for="b in listBusinesses"
                    :key="b.id"
                    :label="b.establishmentName"
                    :value="b.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button
                class="btn btn-danger"
                @click="$modal.hide('clonarTurnosModal')"
              >
                <i class="fa fa-times-circle"></i>
                {{ $t("cancelar") }}
              </button>
              <button @click="clonarTurno()" class="btn btn-success">
                <i class="fas fa-save"></i>
                {{ $t("guardar") }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal
        name="copiarTurnoModal"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4>{{ $t("seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios") }}</h4>
          </div>
          <div class="modal-body">
            <label
              ><strong>{{ $t("fecha") }}:</strong></label
            >
            <template v-if="nameView === 'agendaWeek'">
              <el-date-picker
                type="week"
                format="dd-MM-yyyy"
                :picker-options="dateRangeOptions1"
                v-model="dateCopiarHorario"
                :placeholder="$t('seleccioneUnaSemana')"
              >
              </el-date-picker>
            </template>
            <template v-else>
              <datetime
                value-zone="Europe/Madrid"
                :auto="true"
                class="theme-numier"
                format="dd-MM-yyyy"
                :title="$t('fechaInicio')"
                :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                input-class="form-control"
                v-model="dateCopiarHorario"
              ></datetime>
            </template>
          </div>
          <div class="modal-footer">
            <button
              @click="$modal.hide('copiarTurnoModal')"
              class="btn btn-danger"
            >
              <i class="fa fa-times-circle"></i>
              {{ $t("cancelar") }}
            </button>
            <button @click="changeDate()" class="btn btn-success">
              <i class="fas fa-save"></i> {{ $t("guardar") }}
            </button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import $ from "jquery";
import "fullcalendar";
import { Loading } from "element-ui";

import {
  DatePicker,
  Select,
  Badge,
  Option,
  Checkbox,
  CheckboxGroup,
} from "element-ui";

import moment from "moment";

var today = new Date();
var y = today.getFullYear();
var m = today.getMonth();
var d = today.getDate();
export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Badge.name]: Badge,
    [Option.name]: Option,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
  },
  computed: {
    exportHorario() {
      return (
        this.$store.getters.apiUrl +
        "/turnos/exportTurnosOperarios/PDF?idBusiness=" +
        this.idBusiness +
        "&idOperario=" +
        this.idOperarioFiltro +
        "&fechaInicioCalendario=" +
        moment(this.fechaInicioCalendario).unix() +
        "&download=" +
        1 +
        "&fechaFinCalendario=" +
        moment(this.fechaFinCalendario).unix() +
        "&filtroIncidencias=" +
        this.filtro +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
  },
  updated() {
    this.peticionesIniciales++;

    if (this.peticionesIniciales === 3) {
      this.loadingGeneral.close();
    }
  },

  created() {
    this.$store.dispatch("setNameRoute", "Gestión de personal");

    this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

    this.getBusiness();

    if (this.$store.getters.idBusiness) {
      this.idBusiness = this.$store.getters.idBusiness;
    }
  },
  data() {
    return {
      contador: 0,

      //PRUEBAS INICIO PAGINA
      loadingGeneral: null,
      peticionesIniciales: 0,

      events: [],

      //LIST TURNOS CLONAR
      listTurnClon: [],
      selectAll: false,
      clonacionTurno: false,
      listNegociosClon: [],

      //VACACIONES O LABORAL
      tipo: 0,

      //HORAS
      hoursfrom: "00:00:00",
      hoursto: "23:59:59",

      textEvent: "",
      eventInicio: "",
      eventFin: "",

      //BORRAR
      event: "",

      //Editar Evento
      editEvento: false,

      //LIST BUSINESS
      listBusinesses: [],
      idBusiness: 0,

      //DIFERENCIA LA CREACION DE UN TURNO DESDE EL CALENDARIO O DESDE EL BOTON
      turnoCreate: false,

      turnoCustom: {id : -1,
                    nombreTurno : "Sin plantilla",
                    diasSemanales : ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
                    horaInicio :"00:00:00",
                    horaFin : "23:59:59"
                    },
      arrayResult: [],

      //LIST TURNOS

      listTurnos: [],
      
      incidencias: 0,
      vacaciones: 0,
      vacacionesTodas: 0,

      //TURNOS
      turn: {
        nameTurn: "",
        hoursfromTurn: "00:00:00",
        hourstoTurn: "23:59:59",
        days: [],
      },
      //ERRORES TURNOS
      turnError: {
        nameTurn: false,
        hoursfromTurn: false,
        hourstoTurn: false,
        days: false,
      },

      editarTurno: true,

      daysSemanas: [
        { name: this.$t("lunes"), value: "L" },
        { name: this.$t("martes"), value: "M" },
        {
          name: this.$t("miercoles"),
          value: "X",
        },
        { name: this.$t("jueves"), value: "J" },
        { name: this.$t("viernes"), value: "V" },
        {
          name: this.$t("sabado"),
          value: "S",
        },
        { name: this.$t("domingo"), value: "D" },
      ],

      //TURNOS OPERARIOS

      listOperarios: [],

      listFiltradoOperario: [],
      idOperarioFiltro: 0,
      filtro: 0,

      turnOperario: {
        datefrom: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        ).toISOString(),
        dateto: new Date().toISOString(),
        idTurno: 0,
        idOperario: 0,
        hoursFromCustom:"00:00:00",
        hoursToCustom:"23:59:59",
      },

      turnOperarioError: {
        datefrom: false,
        dateto: false,
        idTurno: false,
        idOperario: false,
      },

      fechaInicioCalendario: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        2 - 6
      ).toISOString(),
      fechaFinCalendario: new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        2 + 6
      ).toISOString(),

      fechaInicioView: new Date().toISOString(),

      nameView: "month",

      lazyFetching : false, //nuevo

      revertirFuncion: 0,

      loading: false,

      turnoFijo: false,

      dateCopiarHorario: new Date().toISOString(),

      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },
      permisoUsuario: true,
      permisoBusiness: false,
    };
  },

  methods: {
    entryCopyTurn() {
      this.$modal.show("copiarTurnoModal");
    },
    changeDate() {
      if (!this.dateCopiarHorario) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("laFechaSeleccionadaNoEsValida"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        return;
      }

      var arrayEventCopy = [];
      var arrayTurnoOperarios = [];
      var arrayDates = [];

      if (this.nameView === "agendaWeek") {
        let copyDate = moment(this.dateCopiarHorario).utc().startOf("day");

        //LUNES DE LA SEMANA A COPIAR

        //CREAMOS EL ARRAY DE DIAS (SEMANA X)

        for (let i = 0; i < 7; i++) {
          arrayDates.push(moment(copyDate).add(i, "day"));
        }

        for (var i = 0; i < this.events.length; i++) {
          if (this.events[i].tipo === 0) {
            for (var x = 0; x < arrayDates.length; x++) {
              if (
                this.events[i].start.format("dd") === arrayDates[x].format("dd")
              ) {
                this.events[i].start.set(
                  "month",
                  arrayDates[x].format("M") - 1
                );
                this.events[i].start.set("date", arrayDates[x].format("D"));

                //COMPROBAMOS SI EL TURNO SE CIERRA EL MISMO DIA O EL DIA SIGUIENTE
                if (
                  this.events[i].end.format("dd") === arrayDates[x].format("dd")
                ) {
                  this.events[i].end.set(
                    "month",
                    arrayDates[x].format("M") - 1
                  );
                  this.events[i].end.set("date", arrayDates[x].format("D"));
                } else {
                  let dateAdd = arrayDates[x];

                  this.events[i].end.set(
                    "month",
                    arrayDates[x].format("M") - 1
                  );
                  this.events[i].end.set(
                    "date",
                    arrayDates[x].add(1, "day").format("D")
                  );
                  arrayDates[x].subtract(1, "day");
                }

                arrayEventCopy.push(this.events[i]);
              }
            }
          }
        }

        arrayEventCopy.forEach(function (y) {
          var xObj = {
            datefrom: moment(y.start).unix(),
            dateto: moment(y.end).unix(),
            idOperario: y.idOperario,
          };

          arrayTurnoOperarios.push(xObj);
        });
      } else {
        let copyDate = moment(this.dateCopiarHorario).startOf("day");

        for (let i = 0; i < this.events.length; i++) {
          //COMPROBAMOS SI SE CIERRA EL MISMO DIA
          if (
            this.events[i].end.format("dd") ===
            this.events[i].start.format("dd")
          ) {
            this.events[i].end.set("date", copyDate.format("D"));
          } else {
            this.events[i].end.set("date", copyDate.add(1, "day").format("D"));
          }

          this.events[i].start.set("date", copyDate.format("D"));

          var xObj = {
            datefrom: moment(this.events[i].start).unix(),
            dateto: moment(this.events[i].end).unix(),
            idOperario: this.events[i].idOperario,
          };

          arrayTurnoOperarios.push(xObj);
        }
      }

      this.copyTurnOperario(arrayTurnoOperarios);
    },

    clonarTurno() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        jwt: this.$store.getters.jwt,
        idBusiness: this.idBusiness,
        listBusiness: this.listNegociosClon,
        listTurnos: this.listTurnClon,
      };

      let controller = "clonarTurno";

      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "turnos/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$modal.hide("clonarTurnosModal");

            vm.$notify({
              message: vm.$t("turnoClonadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    seleccionarTodos() {
      if (this.selectAll) {
        this.listTurnClon = [];

        let vm = this;
        this.listTurnos.forEach(function (x) {
          vm.listTurnClon.push(x.id);
        });
      }
    },
    comprobarPermisos() {
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

      this.permisoBusiness = false;
      this.permisoUsuario = false;

      this.idOperarioFiltro = 0;
      this.listTurnClon = [];
      this.listNegociosClon = [];

      this.checkGestionPersonal();
      //this.getOperarios();
      //this.getRegistrosTurnos();
    },
    checkGestionPersonal() {

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          //1 es gestión de personal
          idLicencia: 1
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkLicenciaProductoByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.permisoBusiness = response.data.result;

            if (vm.permisoBusiness) {
              vm.checkPermisosUsuario();
            } else {
              vm.loadingGeneral.close();
            }
          } else {
            console.error("Ha ocurrido un error al comprobar las licencias");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkPermisosUsuario() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          //1 es gestión de personal
          idRestriccion: 70
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getRestrictions", config)
        .then(function (response) {

          vm.permisoUsuario = response.data.response;

          if (vm.permisoUsuario) {

            vm.getOperarios();
            vm.getRegistrosTurnos();
            vm.getRegistrosTurnosOperario();
            
            vm.initCalendar($, false);
          }

          vm.loadingGeneral.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    sendEmail() {
      const controller = "exportTurnosOperarios/PDF";
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idOperario: this.idOperarioFiltro,
          fechaInicioCalendario: moment(this.fechaInicioCalendario).unix(),
          fechaFinCalendario: moment(this.fechaFinCalendario).unix(),
          filtroIncidencias: this.filtro,
          download: 0,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "turnos/" + controller, config)
        .then(function (response) {
          vm.$notify({
            message: vm.$t("correoEnviadoCorrectamente"),
            icon: "nc-icon nc-check-2",
            timeout: 2000,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });

          vm.loadingGeneral.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    showModalBorrarTurno(idTurno) {
      swal({
        title: this.$t("estasSeguroDeBorrarElTurnoSeleccionado"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siBorrarTurno"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteRegistroTurnos(idTurno);
        }
      });
    },

    showModalBorrarTurnoEleccionModal() {
      swal({
        title: this.$t("estasSeguroDeBorrarElTurnoSeleccionado"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siBorrarTurno"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.borrarEvento();
        }
      });
    },

    focusTurnosOperarioModal() {
      this.$refs.idOperario.focus();
    },

    focusTurnosModal() {
      this.$refs.nameTurn.focus();
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          if (!vm.idBusiness) {
            vm.idBusiness = response.data.result[0].id;
          }
          vm.listBusinesses = response.data.result;

          vm.getRegistrosTurnos();
          vm.getOperarios();
          vm.checkGestionPersonal();

          vm.listTurnos.push(vm.turnoCustom);

        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getOperarios() {
      const controller = "getWorkersByBusiness";
      var config = {
        params: {
          pag: 0,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.listFiltradoOperario = [];

      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "workers/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listOperarios = response.data.result.workers;

            if(response.data.result.workers.length){
                vm.turnOperario.idOperario = response.data.result.workers[0].id;
            }

            for (let i = 0; i < response.data.result.workers.length; i++) {
              if (i === 0) {
                let xObj = {
                  id: 0,
                  name: vm.$t("todos"),
                  surName: "",
                };

                vm.listFiltradoOperario.push(xObj);
              }

              let xObj = {
                id: response.data.result.workers[i].id,
                name: response.data.result.workers[i].name,
                surName: response.data.result.workers[i].surName,
              };

              vm.listFiltradoOperario.push(xObj);
            }
          } else {
            vm.loadingGeneral.close();
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

          //                        vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //MODALES

    cerrarModales() {
      this.$modal.hide("agregarEventoModal");
      this.$modal.hide("eleccionModal");
      this.$modal.hide("agregarTurnoOperarioModal");
      this.$modal.hide("agregarTurnoModal");
    },

    openModalCrear() {
      this.$modal.show("agregarEventoModal");
    },
    openModalEleccion() {
      this.$modal.show("eleccionModal");
    },

    openModalEleccionVacaciones() {
      this.$modal.show("eleccionModalVacaciones");
    },

    openModalEditarEvento() {
      this.editEvento = true;
      this.textEvent = this.event.title;
      this.hoursfrom = this.event.start.format("HH:mm");
      this.hoursto = this.event.end.format("HH:mm");
      this.$modal.show("agregarEventoModal");
      this.$modal.hide("eleccionModal");
      this.$modal.hide("eleccionModalVacaciones");
    },

    openModalAgregarTurno() {
      //PONER EN BLANCO EL TURNO
      this.turn.days = [];
      this.turn.nameTurn = "";
      this.turn.hoursfromTurn = "00:00:00";
      this.turn.hourstoTurn = "23:59:59";

      // PONER EN BLANCO LOS ERRORES DEL TURNO

      this.turnError.days = false;
      this.turnError.nameTurn = false;
      this.turnError.hoursfromTurn = false;
      this.turnError.hourstoTurn = false;

      this.editarTurno = false;

      this.$modal.show("agregarTurnoModal");
    },

    openModalEditarTurno(turn) {
      this.editarTurno = true;

      this.turn.days = [];

      this.turnError.days = false;
      this.turnError.nameTurn = false;
      this.turnError.hoursfromTurn = false;
      this.turnError.hourstoTurn = false;

      let vm = this;
      turn.diasSemanales.forEach(function (x) {
        switch (x) {
          case "Lunes":
            vm.turn.days.push("L");
            break;
          case "Martes":
            vm.turn.days.push("M");
            break;
          case "Miércoles":
            vm.turn.days.push("X");
            break;
          case "Jueves":
            vm.turn.days.push("J");
            break;
          case "Viernes":
            vm.turn.days.push("V");
            break;
          case "Sábado":
            vm.turn.days.push("S");
            break;
          case "Domingo":
            vm.turn.days.push("D");
            break;
        }
      });

      this.turn.nameTurn = turn.nombreTurno;
      this.turn.hoursfromTurn = turn.horaInicio;
      this.turn.hourstoTurn = turn.horaFin;
      this.turn.id = turn.id;

      this.$modal.show("agregarTurnoModal");
    },

    openModalAgregarTurnoOperario() {
      if (this.listTurnos.length > 0 || this.turnoFijo) {
        this.$modal.show("agregarTurnoOperarioModal");
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("necesitasCrearAlgunTurnoParaPoderCrearCuadrantes"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "info",
        });
      }
    },

    //CRUD EVENTOS

    agregarEvento() {
      let hours = moment(this.hoursfrom).format("HH");
      let minutes = moment(this.hoursfrom).format("mm");

      let hoursFin = moment(this.hoursto).format("HH");
      let minutesFin = moment(this.hoursto).format("mm");

      this.eventInicio.set({ h: hours, m: minutes });
      this.eventFin.set({ h: hoursFin, m: minutesFin });

      this.eventInicio._ambigTime = false;

      this.eventFin._ambigTime = false;

      let diferenciaDias = this.eventFin.diff(this.eventInicio, "days");

      if (diferenciaDias === 0) {
        //RESTAMOS UN DIA PARA QUE COJA EL MISMO DIA DE LA SELECCION
        this.eventFin.subtract(1, "day").toDate();

        let eventData = {
          title: this.textEvent,
          start: this.eventInicio,
          end: this.eventFin,
          allDay: false,
          className: "event-orange",
        };

        this.$modal.hide("agregarEventoModal");

       // $("#fullCalendar").fullCalendar("renderEvent", eventData, true);
      } else {
        this.eventFin.subtract(diferenciaDias, "day").toDate();

        for (let i = 0; i < diferenciaDias; i++) {
          let eventData = {
            title: this.textEvent,
            start: this.eventInicio,
            end: this.eventFin,
            allDay: false,
            className: "event-orange",
          };

          this.$modal.hide("agregarEventoModal");

          $("#fullCalendar").fullCalendar("renderEvent", eventData, true);

          this.eventInicio.add(1, "day").toDate();
          this.eventFin.add(1, "day").toDate();
        }
      }
    },

    borrarEvento() {
      this.eliminarRegistroTurnosOperario();

      $("#fullCalendar").fullCalendar("removeEvents", this.event.id);

      $("#fullCalendar").fullCalendar("updateEvent", this.event);

      this.$modal.hide("eleccionModal");
      this.$modal.hide("eleccionModal");
      this.$modal.hide("eleccionModalVacaciones");
    },

    checkEvento() {
      swal({
        title: this.$t("estasSeguroDeEditarElTurno"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siEditarTurno"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.editarEvento();
        }
      });
    },

    editarEvento() {
      if (this.event.tipo === 0) {
        let hours = moment(this.hoursfrom).format("H");
        let minutes = moment(this.hoursfrom).format("mm");

        let hoursFin = moment(this.hoursto).format("H");
        let minutesFin = moment(this.hoursto).format("mm");

        this.event.title = this.textEvent;
        this.event.start.set({ h: hours, m: minutes });

        this.event.end.set({ h: hoursFin, m: minutesFin });
      } else {
        this.event.start = moment(this.turnOperario.datefrom)
          .utc()
          .startOf("day");
        this.event.end = moment(this.turnOperario.dateto).utc().endOf("day");
      }

      $("#fullCalendar").fullCalendar("updateEvent", this.event);

      this.$modal.hide("agregarEventoModal");

      this.editarRegistroTurnosOperario();
    },

    //INICIO CALENDARIO

    initCalendar($, ejecutarPeticion) {
      var self = this;
      var $calendar = $("#fullCalendar");
      $calendar.fullCalendar({
        locale: "es",
        lang: "es",
        height: "auto",
        firstDay: 1,
        minTime: "07:00:00",
        maxTime: "29:00:00",
        //ESCALA DEL EVENTO
        //slotDuration: '00:15:00',
        //scrollTime: '00:00:00',
        allDaySlot: false,
        timezone: "UTC",
        slotLabelInterval: "01:00",
        timeFormat: "H:mm",
        defaultView: this.nameView,
        displayEventEnd: {
          month: false,
          basicWeek: true,
          default: true,
        },
        fixedWeekCount: false,
        buttonText: {
          today: self.$t("hoy"),
          month: self.$t("meses"),
          week: self.$t("semanas"),
          day: self.$t("dias"),
        },
        header: {
          left: "title",
          center: "month,agendaWeek,agendaDay",
          right: "prev,next",
        },
        defaultDate: this.fechaInicioView,
        selectable: true,
        selectHelper: true,
        dayNamesShort: ["D", "L", "M", "X", "J", "V", "S"],
        views: {
          month: {
            // name of view
            titleFormat: "MMMM YYYY",
            columnHeaderFormat: "ddd ",
            // other view-specific options here
          },
          week: {
            titleFormat: " MMMM D YYYY",
            columnHeaderFormat: "ddd D",
          },
          day: {
            titleFormat: "D MMM YYYY",
            columnHeaderFormat: "ddd",
          },
        },

        slotLabelFormat: "HH:mm",

        eventClick: function (event, element) {
          self.turnoFijo = false;
          self.event = event;

          if (event.tipo === 0) {
            self.openModalEleccion();
          } else {
            self.openModalEleccionVacaciones();
          }
        },

        eventRender: function (event, eventElement) {
          if (event.icon) {
            eventElement
              .find("span.fc-title")
              .append('<i class="fas fa-exclamation-triangle"></i>');
          }

          if (event.tipo === 1) {
            eventElement
              .find("span.fc-title")
              .append(' <i class="fas fa-umbrella-beach"></i>');
          }
        },

        dayRender: function (date, cell) {},

        eventDrop: function (event, delta, revertFunc) {
          self.revertirFuncion = revertFunc;
          self.event = event;

          self.editarRegistroTurnosOperario();
        },

        select: function (start, end) {
          self.turnoFijo = false;

          if (self.nameView === "agendaWeek" || self.nameView === "agendaDay") {
            self.turnoFijo = true;
          }

          self.turnoCreate = true;
          self.editEvento = false;

          self.eventInicio = start;
          self.eventFin = end;

          self.openModalAgregarTurnoOperario();
        },

        viewRender: function (view, element) {
          self.nameView = view.name;

          if (self.contador === 0) {
            self.contador++;
            self.fechaInicioCalendario = view.start.utc();
            self.fechaFinCalendario = view.end.utc();
            self.getRegistrosTurnosOperario();
          } else {
            if (ejecutarPeticion) {
              ejecutarPeticion = false;
            } else {
              self.fechaInicioView = view.intervalStart;
              self.fechaInicioCalendario = view.start.utc();
              self.fechaFinCalendario = view.end.utc();
              self.getRegistrosTurnosOperario();
            }
          }
        },

        editable: true,
        eventLimit: false,

        events: self.events,
      });
    },

    //CRUD TURNO HORARIO

    checkTurnos() {
      if (this.turn.nameTurn === "") {
        this.turnError.nameTurn = true;
      } else {
        this.turnError.nameTurn = false;
      }

      if (this.turn.hoursfromTurn === "") {
        this.turnError.hoursfromTurn = true;
      } else {
        this.turnError.hoursfromTurn = false;
      }
      if (this.turn.hourstoTurn === "") {
        this.turnError.hourstoTurn = true;
      } else {
        this.turnError.hourstoTurn = false;
      }
      if (this.turn.days.length === 0) {
        this.turnError.days = true;
      } else {
        this.turnError.days = false;
      }

      if (
        this.turnError.nameTurn ||
        this.turnError.hoursfromTurn ||
        this.turnError.hourstoTurn ||
        this.turnError.days
      ) {
        return false;
      } else {
        return true;
      }
    },

    agregarRegistroTurnos() {
      if (this.checkTurnos()) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          jwt: this.$store.getters.jwt,
          turn: this.turn,
          idBusiness: this.idBusiness,
        };

        this.turn.hoursfromTurn = moment(this.turn.hoursfromTurn).format(
          "HH:mm:ss"
        );
        this.turn.hourstoTurn = moment(this.turn.hourstoTurn).format(
          "HH:mm:ss"
        );

        let controller = !this.editarTurno
          ? "newTurnosByBusiness"
          : "editTurnosByBusiness";

        let vm = this;
        this.axios
          .post(
            this.$store.getters.apiUrl + "turnos/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.$modal.hide("agregarTurnoModal");

              vm.getRegistrosTurnos();

              let action = vm.editarTurno ? vm.$t("editado") : vm.$t("creado");

              vm.$notify({
                message:
                  vm.$t("turno") + " " + action + " " + vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.turn.hoursfromTurn = "00:00:00";
              vm.turn.hourstoTurn = "23:59:59";
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    getRegistrosTurnos() {
      this.array = [];
      this.listTurnos = [];
      const controller = "getTurnosByBusiness";
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "turnos/" + controller, config)
        .then(function (response) {
          if (response.data.response) {

            vm.array = response.data.result;
            vm.array.forEach(element => {
              vm.listTurnos.push(element)
            });

            if (response.data.result.length > 0) {
              vm.turnOperario.idTurno = response.data.result[0].id;
            }
          } else {
            vm.loadingGeneral.close();
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    deleteRegistroTurnos(id) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        jwt: this.$store.getters.jwt,
        idTurn: id,
        idBusiness: this.idBusiness,
      };

      let controller = "deleteTurnosByBusiness";

      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "turnos/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.getRegistrosTurnos();

            vm.$notify({
              message: vm.$t("turnoBorradoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // CRUD HORARIOS OPERARIOS

    checkDate() {
      let fechaInicio = moment(this.turnOperario.datefrom)
        .startOf("day")
        .unix();

      let fechaFin = moment(this.turnOperario.dateto).endOf("day").unix();

      if (fechaFin < fechaInicio) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        return false;
      }
      return true;
    },

    checkTurnosOperarios() {
      

      if (
        this.turnOperario.datefrom === null ||
        this.turnOperario.datefrom === ""
      ) {
        this.turnOperarioError.datefrom = true;
      } else {
        this.turnOperarioError.datefrom = false;
      }

      if (
        this.turnOperario.dateto === null ||
        this.turnOperario.dateto === ""
      ) {
        this.turnOperarioError.dateto = true;
      } else {
        this.turnOperarioError.dateto = false;
      }

      if (this.turnOperario.idOperario.length === 0) {
        this.turnOperarioError.idOperario = true;
      } else {
        this.turnOperarioError.idOperario = false;
      }

      if (
        this.turnOperarioError.datefrom ||
        this.turnOperarioError.dateto ||
        this.turnOperarioError.idTurno ||
        this.turnOperarioError.idOperario
      ) {
        return false;
      } else {
        return true;
      }
    },

    creacionArrayDia() {
      if (this.checkTurnosOperarios()) {
        if (this.turnoCreate) {
          let xDiferenciaDias = this.eventFin.diff(this.eventInicio, "days");

          if (xDiferenciaDias === 0) {
            this.turnOperario.datefrom = this.eventInicio;
            this.turnOperario.dateto = this.eventFin;
          } else {
            this.turnOperario.datefrom = this.eventInicio;
            this.turnOperario.dateto = this.eventFin.subtract(1, "day");
          }
        }

        let fechaInicio = this.turnOperario.datefrom;
        let fechaFin = this.turnOperario.dateto;

        if (this.checkDate()) {
          let xlistaDiasTime = [];

          let vm = this;
          let xTurn = 0;

          this.listTurnos.forEach(function (x) {
            if (x.id === vm.turnOperario.idTurno) {
              xTurn = x;
            }
          });

          //ESTA COMPROBACION SE HACE PARA SABER SI EL HORARIO EMPIEZA EN UN DIA Y TERMINA EN OTRO

          var fechaSeteadasInit = 0;
          var fechaSeteadasFin = 0;

          if (!this.turnoFijo) {
            let xFechaInicio = moment(this.turnOperario.datefrom)
              .utc()
              .startOf("day");

            let xFechaFin = moment(this.turnOperario.dateto)
              .utc()
              .startOf("day")
              .add(1, "day");

            if (this.tipo === 0) {

              if (xTurn.horaFin < xTurn.horaInicio) {
                fechaSeteadasInit = moment(this.turnOperario.datefrom)
                  .utc()
                  .startOf("day");

                fechaSeteadasFin = moment(this.turnOperario.datefrom)
                  .utc()
                  .startOf("day")
                  .add(1, "day");
              } else {
                fechaSeteadasInit = moment(this.turnOperario.datefrom)
                  .utc()
                  .startOf("day");

                fechaSeteadasFin = moment(this.turnOperario.datefrom)
                  .utc()
                  .startOf("day");
              }

              let fechaInicio = "";
              let fechaFin = "";
              let xhoras = "";
              let xminutos = "";
              let xhorasFin = "";
              let xminutosFin = "";

              // nuevo
       
              if(this.turnOperario.idTurno == -1){
                xhoras = this.turnOperario.hoursFromCustom.substring(11, 13); // aqui me daba error si ponia los mismos valores que abajo porque no esta igual formateado asi que yo tengo que pillar otros indices
                xminutos = this.turnOperario.hoursFromCustom.substring(14, 16);

                xhorasFin = this.turnOperario.hoursToCustom.substring(11, 13);
                xminutosFin = this.turnOperario.hoursToCustom.substring(14, 16);

                } else{
                  // esto es lo antiguo
                  xhoras = xTurn.horaInicio.substring(0, 2); 
                  xminutos = xTurn.horaInicio.substring(3, 5);

                  xhorasFin = xTurn.horaFin.substring(0, 2);
                  xminutosFin = xTurn.horaFin.substring(3, 5);

                } 
              
              fechaInicio = fechaSeteadasInit.set({ h: xhoras, m: xminutos });

              fechaFin = fechaSeteadasFin.set({ h: xhorasFin, m: xminutosFin });

              let diferenciaDias = xFechaFin.diff(xFechaInicio, "days");

              for (let i = 0; i < diferenciaDias; i++) {
                let diaSemana = fechaInicio.format("dddd");

                for (let x = 0; x < xTurn.diasSemanales.length; x++) {
                  if (
                    xTurn.diasSemanales[x].toLowerCase() ===
                    diaSemana.toLowerCase()
                  ) {
                    let xdate = {
                      fechaInicio: fechaInicio.unix(),
                      fechaFin: fechaFin.unix(),
                    };

                    xlistaDiasTime.push(xdate);
                  }
                }

                fechaInicio.add(1, "day").toDate();
                fechaFin.add(1, "day").toDate();
              }
            } else {
              let xdate = {
                fechaInicio: xFechaInicio.unix(),
                fechaFin: xFechaFin.unix(),
              };

              xlistaDiasTime.push(xdate);
            }
          } else {
            let xFechaInicio = moment(this.turnOperario.datefrom).utc();

            let xFechaFin = moment(this.turnOperario.dateto).utc();

            let xdate = {
              fechaInicio: xFechaInicio.unix(),
              fechaFin: xFechaFin.unix(),
            };

            xlistaDiasTime.push(xdate);
          }

          if (xlistaDiasTime.length > 0) {
            this.agregarRegistroTurnosOperario(xlistaDiasTime);
          } else {
            this.$modal.hide("agregarTurnoOperarioModal");
            swal({
              title: this.$t("informacion"),
              text: this.$t(
                "elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido"
              ),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "info",
            });
          }
        }

        this.turnOperario.datefrom = fechaInicio;
        this.turnOperario.dateto = fechaFin;
      }
    },
    copyTurnOperario(xTurnWorker) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
        idBusiness: this.idBusiness,
        tipo: this.tipo,
        turnWorker: xTurnWorker,
      };

      let controller = "copyTurnWorkerByBusiness";
      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "turnos/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$modal.hide("copiarTurnoModal");

            vm.$notify({
              message: vm.$t("turnoCopiadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    agregarRegistroTurnosOperario(xlistaDias) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
        turnOperario: this.turnOperario,
        idBusiness: this.idBusiness,
        dias: xlistaDias,
        tipo: this.tipo,
      };

      let controller = "newTurnosOperarioByBusiness";
      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "turnos/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$modal.hide("agregarTurnoOperarioModal");

            vm.filtro = 0;
            vm.getRegistrosTurnosOperario();

            if (response.data.message !== "") {
              swal({
                title: vm.$t("informacion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "info",
              });
            } else {
              vm.$notify({
                message: vm.$t("turnoDeOperarioAgregadoCorrectamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      this.turn.hoursfromTurn = "00:00:00";
      this.turn.hourstoTurn = "23:59:59";
    },

    randDarkColor() {
      var lum = -0.15;
      var hex = String(
        "#" + Math.random().toString(16).slice(2, 8).toUpperCase()
      ).replace(/[^0-9a-f]/gi, "");
      if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      var rgb = "#",
        c,
        i;
      for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
      }
      return rgb;
    },

    getRegistrosTurnosOperario() {
      const controller = "getTurnosOperarioByBusiness";
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idOperario: this.idOperarioFiltro,
          fechaInicioCalendario: moment(this.fechaInicioCalendario).unix()-2629743,
          fechaFinCalendario: moment(this.fechaFinCalendario).unix()+2629743,
          filtroIncidencias: this.filtro,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "turnos/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.events = [];

            let nameOperario = "";
            var mycolor = "";
            var mycolorText = "";
            let xDiferenciaDias = 0;

            let xVacacionesAnuales = 0;

            vm.incidencias = response.data.result.incidencia;

            for (
              let e = 0;
              e < response.data.result.vacacionesAnual.length;
              e++
            ) {
              let fechaInicio = moment.unix(
                response.data.result.vacacionesAnual[e].horaInicio
              );
              let fechaFin = moment.unix(
                response.data.result.vacacionesAnual[e].horaFin
              );

              xVacacionesAnuales += fechaFin.diff(fechaInicio, "days");
            }

            for (let i = 0; i < response.data.result.listTurnos.length; i++) {
              if (response.data.result.listTurnos[i].tipo === 1) {
                let fechaInicio = moment.unix(
                  response.data.result.listTurnos[i].horaInicio
                );
                let fechaFin = moment.unix(
                  response.data.result.listTurnos[i].horaFin
                );

                xDiferenciaDias += fechaFin.diff(fechaInicio, "days");
              }

              if (
                nameOperario !==
                response.data.result.listTurnos[i].nombreOperario
              ) {
                if (vm.filtro === 0) {
                  mycolor = vm.randDarkColor();
                  mycolorText = "white";
                } else if (response.data.result.listTurnos[i].tipo === 1) {
                  mycolorText = "white";
                  mycolor = "#FF6400";
                } else {
                  mycolorText = "white";
                  mycolor = vm.randDarkColor();
                }

                nameOperario =
                  response.data.result.listTurnos[i].nombreOperario;
              }

              var fechaRealInicio = 0;
              var fechaRealFin = 0;

              if (response.data.result.listTurnos[i].horaInicioReal !== "0") {
                fechaRealInicio = moment.unix(
                  response.data.result.listTurnos[i].horaInicioReal
                );
              }
              if (response.data.result.listTurnos[i].horaFinReal !== "0") {
                fechaRealFin = moment.unix(
                  response.data.result.listTurnos[i].horaFinReal
                );
              }

              let xObje = {
                id: response.data.result.listTurnos[i].id,
                title: response.data.result.listTurnos[i].nombreOperario + "  ",
                idOperario: response.data.result.listTurnos[i].idOperario,
                start: moment.unix(
                  response.data.result.listTurnos[i].horaInicio
                ),
                end: moment.unix(response.data.result.listTurnos[i].horaFin),
                diffHorasTrabajadas:
                  response.data.result.listTurnos[i].diffHorasTrabajadas,
                diffHorasTurno:
                  response.data.result.listTurnos[i].diffHorasTurno,
                allDay: false,
                icon: response.data.result.listTurnos[i].alert,
                tipo: response.data.result.listTurnos[i].tipo,
                backgroundColor: mycolor,
                textColor: mycolorText,
                startReal: fechaRealInicio,
                endReal: fechaRealFin,
              };
              vm.events.push(xObje);
            }

            vm.vacacionesTodas = xVacacionesAnuales;
            vm.vacaciones = xDiferenciaDias;

            $("#fullCalendar").fullCalendar("destroy");

            vm.initCalendar($, true);
          } else {
            vm.loadingGeneral.close();
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    eliminarRegistroTurnosOperario() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
        idBusiness: this.idBusiness,
        id: this.event.id,
      };

      let controller = "deleteTurnosOperarioByBusiness";
      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "turnos/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("turnoDeOperarioEliminadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editarRegistroTurnosOperario() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      //SE CREA UN OBJETO PORQUE DA ERROR AL PASAR EL OBJETO EVENT
      let xObj = {
        id: this.event.id,
        idOperario: this.event.idOperario,
        horaInicio: this.event.start.unix(),
        horaFin: this.event.end.unix(),
      };

      var params = {
        jwt: this.$store.getters.jwt,
        idBusiness: this.idBusiness,
        turn: xObj,
      };

      let vm = this;
      let controller = "editTurnosOperarioByBusiness";
      this.axios
        .post(
          this.$store.getters.apiUrl + "turnos/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.message !== "") {
              swal({
                title: vm.$t("informacion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "info",
              });

              vm.revertirFuncion();
            } else {
              vm.$notify({
                message: vm.$t("turnoDeOperarioEditadoCorrectamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted() {
    window.$ = window.jQuery = $;
  },
};
</script>
<style>
#fullCalendar {
  min-height: 300px;
}

.el-loading-spinner .path {
  stroke: #66615b !important;
}

.fc-content {
  font-size: 13px;
}

.card {
  padding: 20px;
}

/*CLASES DEL CALENDARIO*/

.fc-event-container {
  width: 80%;
}

.fc .fc-head .fc-widget-header {
  text-align: center;
  margin-bottom: 4px;
}

.fc .fc-head .fc-widget-header span {
  display: inline-block;
  min-width: 20px;
  font-weight: bold;
  height: 20px;
  font-size: 15px;
  background-color: #1E22AA;
  border: solid #1E22AA 8px;
  border-radius: 360250px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/RegistroHorarios/Calendar.vue